import { Field } from '../../../Common/forms'
import { IconPopoverLabel } from '../../Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import { PopoverImg, ProposalBlock } from '@vzmi/shp_shared_compo'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import { SingleVideoUploaderFieldContainer } from '../../Common/ProposalForm/Video/Video'
import styles from './index.css'

export const getCustomVideoSectionTitle = title => {
  return (
    <IconPopoverLabel
      className={styles.sectionTitle}
      popoverContent={(
        <PopoverImg
          url={`${CDN}/img/tooltip_video.png`}
          width={500}
          height={500}
        />
      )}
    >
      {title}
    </IconPopoverLabel>
  )
}

const UpdateVideo = props => {
  const { readOnly } = props
  return (
    <ProposalBlock>
      <Field
        name='video'
        component={SingleVideoUploaderFieldContainer}
        readOnly={readOnly}
      />
    </ProposalBlock>
  )
}

export default UpdateVideo
